<template>
  <div
    class="hero-canvas-background"
    style="--color-canvas: var(--app-canvas-color-canvas, #002a95)"
  >
    <div class="hero-canvas-background__outer">
      <div
        class="hero-canvas-background__inner"
        style="--effect-opacity: var(--app-canvas-effect-opacity, 0)"
      >
        <div class="hero-canvas-background__filter" />
      </div>
    </div>
  </div>
</template>
